import { Wrapper, Article, Header, Content, Footer } from './styles'

export default function PrivacyPolicy() {
  return (
    <Wrapper>
      <Article>
        <Header>
          <img src="/logo.svg" alt="MeniuDigital" className="logo" />
          <h1>Politica de confidențialitate</h1>
          <div className="subtitle">Actualizat: 13 Noiembrie 2024</div>
        </Header>

        <Content>
          <p>
            Acest document privind politica de confidențialitate conține tipuri de informații care sunt colectate și
            înregistrate de MeniuDigital și modul în care le folosim.
          </p>

          <p>
            Dacă aveți întrebări suplimentare sau aveți nevoie de mai multe informații despre politica noastră de
            confidențialitate, nu ezitați să ne contactați.
          </p>

          <div className="highlight">
            Această politică de confidențialitate se aplică numai activităților noastre online și este valabilă pentru
            vizitatorii Platformei cu privire la informațiile pe care le-au distribuit și / sau colectat în MeniuDigital.
          </div>

          <h2>Consimțământ</h2>
          <p>
            Prin utilizarea Platformei noastre web, sunteți de acord cu politica noastră de confidențialitate și sunteți de
            acord cu termenii acesteia.
          </p>

          <h2>Informațiile pe care le colectăm</h2>
          <p>
            Informațiile personale pe care vi se cere să le furnizați și motivele pentru care vi se solicită să le furnizați,
            vă vor fi clarificate în momentul în care vă rugăm să furnizați informațiile dvs. personale.
          </p>

          <p>
            Dacă ne contactați direct, este posibil să primim informații suplimentare despre dvs., cum ar fi numele dvs.,
            adresa de e-mail, numărul de telefon, datele de identificare ale companiei dvs., sau orice alte informații pe care
            ați putea să le furnizați.
          </p>

          <p>
            Când vă înregistrați pentru un cont, este posibil să vă solicităm informațiile de contact, inclusiv elemente
            precum numele, numele companiei, adresa, date de identificare ale companiei, adresa de e-mail și/sau numărul de
            telefon.
          </p>

          <h2>Cum utilizăm informația</h2>
          <p>Folosim informațiile pe care le colectăm în diferite moduri, inclusiv pentru:</p>
          <ul>
            <li>Furnizarea, operarea și întreținerea Platformei noastre</li>
            <li>Îmbunătățirea, personalizarea și extinderea Platformei noastre</li>
            <li>Înțelegerea și analizarea modului în care utilizați site-ul nostru web</li>
            <li>Dezvoltăm produse, servicii, caracteristici și funcționalități noi</li>
            <li>
              Comunicarea cu dvs., direct sau prin intermediul unuia dintre partenerii noștri, inclusiv pentru servicii pentru
              clienți, pentru a vă oferi actualizări și alte informații referitoare la site-ul web și în scopuri de marketing
              și de promovare
            </li>
            <li>Trimiterea de email-uri</li>
            <li>Găsirea și prevenirea fraudei</li>
          </ul>

          <h2>Fișiere jurnal</h2>
          <p>
            MeniuDigital urmează o procedură standard de utilizare a fișierelor jurnal. Aceste fișiere înregistrează
            vizitatori atunci când accesează site-uri web. Toate companiile de găzduire fac acest lucru și o parte din analiza
            serviciilor de găzduire. Informațiile colectate de fișierele jurnal includ adrese de protocol de internet (IP),
            tip de browser, furnizor de servicii Internet (ISP), ștampilă de dată și oră, pagini de trimitere / ieșire și,
            eventual, numărul de clicuri.
          </p>

          <p>
            Acestea nu sunt legate de nicio informație care poate fi identificată personal. Scopul informațiilor este de a
            analiza tendințele, de a administra site-ul, de a urmări mișcarea utilizatorilor de pe site și de a colecta
            informații demografice.
          </p>

          <h2>Cookie-uri și semnalizatoare web</h2>
          <p>
            Ca orice alt site web, MeniuDigital folosește „cookie-uri". Aceste cookie-uri sunt utilizate pentru a stoca
            informații, inclusiv preferințele vizitatorilor, și paginile de pe site-ul web pe care vizitatorul le-a accesat
            sau le-a vizitat. Informațiile sunt utilizate pentru a optimiza experiența utilizatorilor prin personalizarea
            conținutului paginii noastre web pe baza tipului de browser al vizitatorilor și / sau a altor informații.
          </p>

          <p>
            Pentru informații mai generale despre cookie-uri, vă rugăm să citiți{' '}
            <a href="https://www.cookieconsent.com/what-are-cookies/" target="_blank" rel="noopener noreferrer">
              "Ce Sunt Cookie-urile?"
            </a>
            .
          </p>

          <h2>Politici de confidențialitate pentru partenerii de publicitate</h2>
          <p>
            Serverele de publicitate terțe sau rețelele publicitare utilizează tehnologii precum cookie-uri, JavaScript sau
            Web Beacon-uri care sunt utilizate în reclamele și linkurile respective care apar pe MeniuDigital, care sunt
            trimise direct în browserul utilizatorilor. Ei primesc automat adresa dvs. IP atunci când se întâmplă acest lucru.
          </p>

          <p>
            Aceste tehnologii sunt utilizate pentru a măsura eficiența campaniilor lor publicitare și / sau pentru a
            personaliza conținutul publicitar pe care îl vedeți pe site-urile web pe care le vizitați.
          </p>

          <div className="highlight">
            Rețineți că MeniuDigital nu are acces sau control asupra acestor cookie-uri care sunt utilizate de agenții de
            publicitate terți.
          </div>

          <h2>Drepturile de protecție a datelor GDPR</h2>
          <p>
            Dorim să ne asigurăm că sunteți pe deplin conștienți de toate drepturile dvs. de protecție a datelor. Fiecare
            utilizator are dreptul la următoarele:
          </p>

          <h3>Dreptul de acces</h3>
          <p>
            Aveți dreptul de a solicita copii ale datelor dvs. personale. Este posibil să vă taxăm o mică taxă pentru acest
            serviciu.
          </p>

          <h3>Dreptul la rectificare</h3>
          <p>
            Aveți dreptul să solicitați să corectăm orice informație pe care o considerați inexactă. De asemenea, aveți
            dreptul să solicitați completarea informațiilor pe care le considerați incomplete.
          </p>

          <h3>Dreptul la ștergere</h3>
          <p>Aveți dreptul să solicitați ștergerea datelor dvs. personale, în anumite condiții.</p>

          <h3>Dreptul de a restricționa prelucrarea</h3>
          <p>
            Aveți dreptul să solicitați restricționarea prelucrării datelor dvs. personale, în anumite condiții.
          </p>

          <h3>Dreptul de a vă opune prelucrării</h3>
          <p>
            Aveți dreptul de a vă opune prelucrării datelor dumneavoastră cu caracter personal, în anumite condiții.
          </p>

          <h3>Dreptul la portabilitatea datelor</h3>
          <p>
            Aveți dreptul să solicitați transferul datelor pe care le-am colectat către o altă organizație sau direct către
            dvs., în anumite condiții.
          </p>

          <div className="info-box">
            <p>
              <strong>Răspuns la solicitări:</strong> Dacă faceți o solicitare, avem o lună pentru a vă răspunde. Dacă doriți
              să vă exercitați oricare dintre aceste drepturi, vă rugăm să ne contactați.
            </p>
          </div>

          <h2>Informațiile minorilor</h2>
          <p>
            O altă parte a priorității noastre este adăugarea de protecție pentru copii în timpul utilizării internetului. Îi
            încurajăm pe părinți și tutori să observe, să participe și / sau să monitorizeze și să îndrume activitatea lor
            online.
          </p>

          <p>
            MeniuDigital nu colectează cu bună știință nicio informație personală de identificare de la copiii cu vârsta sub
            13 ani. Dacă credeți că copilul dumneavoastră a furnizat acest tip de informații pe site-ul nostru, vă încurajăm
            cu tărie să ne contactați imediat și vom depune toate eforturile pentru eliminați astfel de informații din
            înregistrările noastre.
          </p>
        </Content>

        <Footer>
          <h3>Contact</h3>
          <div className="company-info">
            <strong>TOUCHFREEMENU SRL</strong>
            Strada Șugău nr. 46A
            <br />
            Sighetu Marmației, Maramureș 435500
            <br />
            România
            <br />
            <br />
            <strong>E-mail:</strong> <a href="mailto:contact@meniudigital.ro">contact@meniudigital.ro</a>
            <br />
            <br />
            C.U.I.: 44695880
            <br />
            Reg.Com.: J24/1306/05.08.2021
          </div>

          <div className="links">
            <a href="/delivery-terms">Politica de livrare</a>
            <a href="/cancellation-policy">Politica de anulare</a>
            <a href="/terms-and-conditions">Termeni și condiții</a>
          </div>
        </Footer>
      </Article>
    </Wrapper>
  )
}
